/* eslint-disable */
import createIcon from '../createIcon';

const IconCheckSquareFilled = createIcon({
  name: 'icon-check-square-filled',
  content: '<title>复选框/对勾</title><g stroke-width="1" fill="none" fill-rule="evenodd"><path d="M1024,0 L1024,1024 L0,1024 L0,0 L1024,0 Z M805.82251,218 L398.529,625.294 L217.509668,444.27417 L127,534.783838 L308.02,715.803 L398.529004,806.312842 L896.332178,308.509668 L805.82251,218 Z" fill="currentColor"/></g>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconCheckSquareFilled;
